import { useTypedParams } from '@sorare/routing';

import { RewardsFixtureLayout } from '#src/layouts/rewards/RewardsFixtureLayout/index.tsx';

import type { LayoutParams } from './__generated__/routeParams.ts';

const RewardsFixtureLayoutPage = () => {
  const { fixture, league, tier, rarity } = useTypedParams<LayoutParams>();
  return (
    <RewardsFixtureLayout
      fixture={fixture}
      league={league}
      tier={tier}
      rarity={rarity}
    />
  );
};

export default RewardsFixtureLayoutPage;
